import React, { FC, ReactNode } from 'react';

import { Text } from '@nord/ui';

import LazyImage from '../../../../atoms/LazyImage';
import TwoColView from '../../../../templates/TwoColView';
import resetPasswordLowResImg from '../../../assets/img/Reset-pass.png';
import resetPasswordImg from '../../../assets/img/Reset-pass.svg';
import Form, {
  IResetPasswordFormText,
  IResetPasswordValues,
} from '../../organisms/ResetPasswordForm';

export interface IProps {
  isSubmitting?: boolean;
  onSubmit: (values: IResetPasswordValues) => Promise<boolean | Record<string, string>>;
  resetPasswordTitle?: ReactNode;
}

const ResetPassword: FC<IProps & IResetPasswordFormText> = ({
  isSubmitting,
  onSubmit,
  resetPasswordTitle = 'Reset your password',
  ...restProps
}) => (
  <TwoColView
    leftPanel={
      <LazyImage src={resetPasswordImg} alt="Forgot password" preview={resetPasswordLowResImg} />
    }
  >
    <div className="md:mr-5">
      <Text className="mb-8px reset-password-header text-grey-tuna font-bold" variant="subtitle1">
        {resetPasswordTitle}
      </Text>
      <Form {...restProps} onSubmit={onSubmit} isSubmitting={isSubmitting} />
    </div>
  </TwoColView>
);

export default ResetPassword;
